<template>
  <div class="small-content-fotter">
    <p
      class="prev"
      :class="{ noActive: prev.name === '无' }"
      @click="handleChange(prev)"
    >
      上一项：{{ prev.name }}
    </p>
    <p
      class="next"
      :class="{ noActive: next.name === '无' }"
      @click="handleChange(next)"
    >
      下一项：{{ next.name }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      // 数据集
      type: Array,
      default: () => [],
    },
    currentId: {
      // 当前访问的疾病id
      type: [String, Number],
      default: "",
    },
    currentScode: {
      // 当前样本编号
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {
    prev() {
      // 上一项
      const currentIndex = this.list.findIndex(
        (item) => item.itemid === this.currentId + ""
      );
      if (currentIndex === 0 || currentIndex === -1) {
        return {
          name: "无",
        };
      }
      if (currentIndex > 0) {
        const currentPrev = this.list[currentIndex - 1];
        return {
          ...currentPrev,
          name: currentPrev.chname,
        };
      }
    },
    next() {
      // 下一项
      const currentIndex = this.list.findIndex(
        (item) => item.itemid === this.currentId + ""
      );
      if (currentIndex === this.list.length - 1) {
        return {
          name: "无",
        };
      }
      if (currentIndex < this.list.length - 1) {
        const currentNext = this.list[currentIndex + 1];
        return {
          ...currentNext,
          name: currentNext.chname,
        };
      }
    },
  },
  methods: {
    handleChange(value) {
      // 仅修改路由参数，路由不变
      if (value.name !== "无") {
        this.$router.push({
          path: `/desease/details/${value.scode_type}/${this.currentScode}/${value.itemid}`,
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.small-content-fotter {
  padding: 0 0.15rem;
  margin-top: 0.1rem;
  color: #007aff;
  .prev,
  .next {
    margin: 0.15rem 0;
    margin-bottom: 0.15rem;
    cursor: pointer;
  }
  .noActive {
    color: #9f9fa0;
  }
  span {
    color: #9f9fa0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/smallGlobal/GlobalFooter.vue